import React, { useState } from 'react';
import { Game } from '../data/games';
import MediaLightbox from './MediaLightbox';

const MEDIA_COUNT = 6;

export function getGameMediaPhotos(game: Game): string[] {
  if (game.media.length > 0) {
    return game.media.length > MEDIA_COUNT ? game.media.slice(0, MEDIA_COUNT) : game.media;
  }

  const sources = [game.featuredImage, game.image];
  const photos: string[] = [];

  for (let index = 0; index < MEDIA_COUNT; index += 1) {
    photos.push(sources[index % sources.length]);
  }

  return photos;
}

type GameMediaProps = {
  game: Game;
};

function GameMedia({ game }: GameMediaProps) {
  const photos = getGameMediaPhotos(game);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  return (
    <section className="kg-section kg-game-media">
      <div className="kg-game-media-inner">
        <h2 className="kg-game-media-title">Media</h2>
        <div className={`kg-game-media-grid${photos.length === 4 ? ' kg-game-media-grid--four' : ''}`}>
          {photos.map((src, index) => (
            <figure key={`${game.slug}-media-${index}`} className="kg-game-media-item">
              <button
                type="button"
                className="kg-game-media-trigger"
                onClick={() => setActiveIndex(index)}
                aria-label={`View ${game.title} screenshot ${index + 1}`}
              >
                <img
                  src={src}
                  alt={`${game.title} screenshot ${index + 1}`}
                  className="kg-game-media-img"
                  loading="lazy"
                />
              </button>
            </figure>
          ))}
        </div>
      </div>

      {activeIndex !== null ? (
        <MediaLightbox
          photos={photos}
          gameTitle={game.title}
          activeIndex={activeIndex}
          onClose={() => setActiveIndex(null)}
          onNavigate={setActiveIndex}
        />
      ) : null}
    </section>
  );
}

export default GameMedia;
